import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

const OLDEST_SUPPORTED_API_VERSION = "3.19";

export const tableau = defineConnector({
  identifier: "tableau",
  name: "Tableau",
  tagLine: "Analytics and data visualization platform",
  keywords: "bi business intelligence dashboards workbooks views datasources",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.serverUrl}/api/${OLDEST_SUPPORTED_API_VERSION}/auth/signin`,
        headers: [
          {
            name: "content-type",
            value: "application/xml",
          },
          {
            name: "accept",
            value: "application/json",
          },
        ],
        rawBody: `<tsRequest><credentials personalAccessTokenName="${app.config.tokenName}" personalAccessTokenSecret="${app.secret.tokenSecret}"><site contentUrl="${app.config.siteContentUrl}"/></credentials></tsRequest>`,
      },
      extract: { from: "jsonPath", paths: ["credentials.token"] },
      apply: { kind: "header", name: "x-tableau-auth" },
    }),
  steps: [
    {
      title: "Create a Tableau personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Tableau Cloud or Tableau Server, open **My Account Settings** and create a **Personal Access Token**. Copy the token name and token secret.",
        },
      ],
    },
    {
      title: "Enter your Tableau details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://prod-useast-a.online.tableau.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText:
            "Use your Tableau Server base URL, or your Tableau Cloud pod URL such as prod-useast-a.online.tableau.com.",
        },
        {
          kind: "input",
          label: "Site content URL",
          placeholder: "my-site",
          target: { kind: "configuration", field: "siteContentUrl" },
          helperText:
            "For Tableau Cloud, enter the site content URL. For Tableau Server, leave this empty only if you use the default site.",
        },
        {
          kind: "input",
          label: "Token name",
          required: true,
          target: { kind: "configuration", field: "tokenName" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => ({
      url: `${serverUrl}/api/${OLDEST_SUPPORTED_API_VERSION}/sessions/current`,
      expectedStatus: [200],
    }),
  },
});
